import _VaMenu from './VaMenu.vue'
import { withConfigTransport } from '../../services/config-transport'

export const VaMenu = withConfigTransport(_VaMenu)
